import { render } from "./ui-hours.vue?vue&type=template&id=3e4fbad2&ts=true"
import script from "./ui-hours.vue?vue&type=script&lang=ts"
export * from "./ui-hours.vue?vue&type=script&lang=ts"

import "./ui-hours.vue?vue&type=style&index=0&id=3e4fbad2&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__